import { Tea } from '@features/libs/tea';

const PAGE_NAME = 'academy_config_module_detailed_page';

export const reportPageShow = () => {
  Tea('page_show', {
    page_name: PAGE_NAME,
  });
};

export const reportPageDuration = (duration: number) => {
  Tea('page_duration', {
    duration,
    page_name: PAGE_NAME,
  });
};

const WEBINAR_PAGE_NAME = 'academy_webinar_portal';
export const reportPageShow_webinar = () => {
  Tea('page_show', {
    page_name: WEBINAR_PAGE_NAME,
  });
};

export const reportContentExposure_webinar = (module_name: string) => {
  Tea('page_show', {
    page_name: WEBINAR_PAGE_NAME,
    module_name,
  });
};

export const reportContentClick_webinar = (
  module_name: string,
  click_for?: string,
  content_id?: string,
  index?: string,
) => {
  Tea('button_click', {
    page_name: WEBINAR_PAGE_NAME,
    module_name,
    click_for,
    content_id,
    index,
  });
};

export const reportPageDuration_webinar = duration => {
  Tea('page_duration', {
    page_name: WEBINAR_PAGE_NAME,
    duration,
  });
};
